var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame4716(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.2676,
    y: 3.39844,
    width: 26.8,
    height: 41.2,
    rx: 3.8,
    stroke: "#2E2E2E",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.6645,
    y: 6.6,
    width: 6,
    height: 1.2,
    rx: 0.6,
    stroke: "#2E2E2E",
    strokeWidth: 1.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.0707,
    y: 34.2016,
    width: 25.2,
    height: 1.2,
    rx: 0.6,
    stroke: "#2E2E2E",
    strokeWidth: 1.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 23.2676,
    y: 38.1992,
    width: 2.8,
    height: 2.8,
    rx: 1.4,
    stroke: "#2E2E2E",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 20.8691,
    y: 26.1992,
    width: 7.6,
    height: 4,
    rx: 2,
    stroke: "#C63031",
    strokeWidth: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 23.4707,
    y: 20.3984,
    width: 2.4,
    height: 2.4,
    rx: 1.2,
    fill: "#C63031"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6738 21.5992V13.1992",
    stroke: "#C63031",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6691 12L19.8691 22.361L21.9491 26.4",
    stroke: "#C63031",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6707 12L29.4707 22.361L27.3907 26.4",
    stroke: "#C63031",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame4716);
export default __webpack_public_path__ + "static/media/Frame 4716.d0200e7b6fa7696cbb9183da3dccec7b.svg";
export { ForwardRef as ReactComponent };